export const DISCOUNT_APPLY_TO_STORAGE = "storage"
export const DISCOUNT_APPLY_TO_ELECTRIC = "electric"
export const DISCOUNT_TYPE_DOLLAR = "dollar"
export const DISCOUNT_TYPE_PERCENT = "percent"
